import { openBlock as e, createElementBlock as t, createElementVNode as l } from "vue";
const o = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 40 40"
}, h = /* @__PURE__ */ l("path", {
  fill: "#F0F0F0",
  d: "M20 40c11.046 0 20-8.954 20-20S31.046 0 20 0 0 8.954 0 20s8.954 20 20 20Z"
}, null, -1), n = /* @__PURE__ */ l("path", {
  fill: "#338AF3",
  d: "M20 40c7.93 0 14.78-4.614 18.015-11.304H1.985C5.218 35.386 12.07 40 20 40Zm0-40C12.07 0 5.22 4.614 1.984 11.304h36.031C34.78 4.614 27.93 0 20 0Zm-7.692 13.043.648 1.993h2.095l-1.695 1.232.648 1.993-1.696-1.232-1.695 1.232.647-1.993-1.695-1.232h2.096l.647-1.992Zm0 8.697.648 1.992h2.095l-1.695 1.232.648 1.992-1.696-1.231-1.695 1.231.647-1.992-1.695-1.232h2.096l.647-1.993Zm15.384-8.697.647 1.993h2.096l-1.696 1.232.648 1.993-1.695-1.232-1.696 1.232.648-1.993-1.695-1.232h2.095l.648-1.992Zm0 8.697.647 1.992h2.096l-1.696 1.232.648 1.992-1.695-1.231-1.696 1.231.648-1.992-1.695-1.232h2.095l.648-1.993ZM20 17.391l.648 1.993h2.095l-1.695 1.232.647 1.993L20 21.377l-1.695 1.232.647-1.993-1.695-1.232h2.095L20 17.391Z"
}, null, -1), c = [
  h,
  n
];
function s(r, d) {
  return e(), t("svg", o, [...c]);
}
const m = { render: s };
export {
  m as default,
  s as render
};
